/**
 *
 * LocationControl
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withLeaflet } from 'react-leaflet';
// import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { white, green500, green700 } from 'styles/colors';
import IconButton from 'components/IconButton';
import { trackLabel } from 'utils/analytics';
import { reportError } from 'utils/Sentry';
// import messages from './messages';

const ToggleButton = styled(IconButton)`
  &.btn.active.active {
    color: ${white};
    background-color: ${green500};
    &:hover {
      color: ${white};
      background-color: ${green700};
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class LocationControl extends React.PureComponent {
  static getDerivedStateFromProps(props, state) {
    const { dragged } = props;
    const { watching } = state;
    if (dragged && watching) {
      return { watching: false };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = { watching: false };
    this.watchId = null;
    this.marker = null;
    this.track = trackLabel({ category: 'Map', action: 'Current Location' });
  }

  componentDidUpdate() {
    const { watching } = this.state;
    if (this.watchId && !watching) {
      this.stopWatching();
    }
  }

  componentWillUnmount() {
    this.stopWatching();
  }

  moveMap = loc => {
    const position = { lat: loc.coords.latitude, lng: loc.coords.longitude };
    const { onChange, leaflet } = this.props;
    try {
      const zoom = this.started && leaflet.map.getZoom() < 16 ? 16 : undefined;
      this.started = false;
      leaflet.map.setView(position, zoom);
      onChange(position);
    } catch (err) {
      // eslint-disable-next-line no-underscore-dangle
      reportError(err, { position, mapPane: leaflet.map._mapPane });
    }
  };

  watchError = error => {
    console.error(error); // eslint-disable-line no-console
  };

  startWatching = () => {
    this.track('on');
    this.started = true;
    this.watchId = navigator.geolocation.watchPosition(
      this.moveMap,
      this.watchError,
      {
        enableHighAccuracy: true,
        timeout: 1000,
        maximumAge: 0,
      },
    );
  };

  stopWatching = () => {
    this.track('off');
    navigator.geolocation.clearWatch(this.watchId);
    this.watchId = 0;
    const { onChange } = this.props;
    onChange(null);
  };

  toggleWatch = () => {
    this.setState(prev => {
      const watching = !prev.watching;
      if (watching) {
        this.startWatching();
      } else {
        this.stopWatching();
      }
      return { watching };
    });
  };

  render() {
    if (!navigator.geolocation) {
      return null;
    }
    const { watching } = this.state;
    return (
      <ToggleButton
        className="btn-fab"
        icon="crosshairs"
        active={watching}
        onClick={this.toggleWatch}
        aria-label="Follow current location"
      />
    );
  }
}

LocationControl.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  dragged: PropTypes.bool,
  leaflet: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

// export default injectIntl(LocationControl);
export default withLeaflet(LocationControl);
